module.exports = __webpack_public_path__ + "static/media/dashboard.ffc88e7f.svg";